import { render, staticRenderFns } from "./sales-plan-cancel-confirmation.vue?vue&type=template&id=6f2a973b&scoped=true&"
import script from "./sales-plan-cancel-confirmation.vue?vue&type=script&lang=js&"
export * from "./sales-plan-cancel-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./sales-plan-cancel-confirmation.vue?vue&type=style&index=0&id=6f2a973b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2a973b",
  null
  
)

export default component.exports